import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";

export interface IConsultationDatatableRowFormMeta {
  date: FormInputMeta,
  fees: FormInputMeta,
  name: FormInputMeta,
  source: FormInputMeta,
  accountNumber: FormInputMeta,
  amount: FormInputMeta,
  currency: FormInputMeta,
  feesType: FormInputMeta,
  status: FormInputMeta,
  //
  feesTypeName: FormInputMeta,
  total: FormInputMeta,
  count: FormInputMeta,
  changeStatus: FormInputMeta,
  //
  schema: any,
}

const ConsultationDatatableRowFormMeta = {} as IConsultationDatatableRowFormMeta;

ConsultationDatatableRowFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.fees = {
  name: 'fees',
  type: 'text',
  label: 'Frais',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.name = {
  name: 'name',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.source = {
  name: 'source',
  type: 'text',
  label: 'Source',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.accountNumber = {
  name: 'accountNumber',
  type: 'text',
  label: 'Numero compte',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.amount = {
  name: 'amount',
  type: 'text',
  label: 'Montant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.currency = {
  name: 'currency',
  type: 'text',
  label: 'Devise',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.feesType = {
  name: 'feesType',
  type: 'text',
  label: 'Type frais',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
/** */
ConsultationDatatableRowFormMeta.feesType = {
  name: 'feesType',
  type: 'text',
  label: 'Type frais',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.total = {
  name: 'total',
  type: 'number',
  label: 'Total',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.count = {
  name: 'count',
  type: 'number',
  label: 'Compteur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultationDatatableRowFormMeta.changeStatus = {
  name: 'changeStatus',
  type: 'select',
  label: 'Mise a jour de statut',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

ConsultationDatatableRowFormMeta.schema = yup.object().shape(getValidationSchema(ConsultationDatatableRowFormMeta));

export default ConsultationDatatableRowFormMeta;
